import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=409f5254&scoped=true"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"
import style0 from "./PersonForm.vue?vue&type=style&index=0&id=409f5254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409f5254",
  null
  
)

export default component.exports